<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#37D4A3" fill-opacity="0.5"/>
  <path d="M9.95734 16L6.10923 12.1518L7.17576 11.0853L9.95734 13.8669L16.8243 7L17.8908 8.06653L9.95734 16Z" fill="#4563FF" stroke="#4563FF" stroke-width="0.5"/>
</svg>
